import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DealerPayload } from '../models/dealers.model';

@Injectable({
	providedIn: 'root',
})
export class DealershipService {
	constructor(private readonly http: HttpClient) {}

	getAreaSupports(latitude: number, longitude: number) {
		return this.http.get<any>(`${environment.apiUrl}dealerships/verifications/area-supports/latitude/${latitude}/longitude/${longitude}`);
	}

	getDealerships() {
		return this.http.get<any>(`${environment.apiUrl}dealerships`);
	}

	getAvailables(payload: DealerPayload) {
		return this.http.post<any>(`${environment.apiUrl}dealerships/availables`, payload);
	}

	getDealerById(id: string) {
		return this.http.get<any>(`${environment.apiUrl}dealerships/${id}`);
	}

	getDealersByGroup(latitude: number, longitude: number, dealershipGroupId: string) {
		return this.http.get<any>(`${environment.apiUrl}dealerships/near-by-group/latitude/${latitude}/longitude/${longitude}/dealershipGroupId/${dealershipGroupId}`);
	}
}
